import React from 'react';
import { AB_TITLE, CREATE_AB_TEST } from '../../utils/Constants';

type TABHomeHeaderProps = {
    onOpen: () => void;
    hasCreatePermission: boolean
}

const ABHomeHeader = ({ onOpen, hasCreatePermission }: TABHomeHeaderProps) => {
    return (
        <div className={`tw-flex tw-justify-between tw-items-center tw-border-b tw-my-2 tw-pb-1.5`}>
            <label className={`tw-text-black tw-text-xl tw-font-semibold`}>{AB_TITLE}</label>
            <button className={`button-style tw-w-max`} disabled={!hasCreatePermission} onClick={onOpen}>{CREATE_AB_TEST}</button>
        </div>
    );
}

export default ABHomeHeader;